import React, {useState, useEffect, useMemo}		from 'react';
import {useNavigate, useSearchParams}				from 'react-router-dom';
import moment										from 'moment';

import Devices										from '../Devices';
import Button										from '../../ressources/components/Button';
import Icon											from '../../ressources/components/Icon';
import Tabs											from '../../ressources/components/Tabs';
import ButtonStickyContainer						from '../../ressources/components/Button/ButtonStickyContainer';
import Checkbox										from '../../ressources/components/Checkbox';
import Badge										from '../../ressources/components/Badge';
import Load											from '../../ressources/components/Load';
import Section										from '../../ressources/components/Section';
import Select										from '../../ressources/components/Select';
import {TabsValues}									from '../../ressources/components/Tabs/interface';
import {FilterChecked}								from '../../ressources/components/Modal/interface';
import ModalMdmCommand								from '../../ressources/components/ModalMdmCommand';
import ModalFilter									from '../../ressources/components/ModalFilter';
import ModalAssign									from '../../ressources/components/ModalAssign';
import Input										from '../../ressources/components/Input';

import {useAppDispatch, useAppSelector}				from '../../app/hooks';
import {LanguageType}								from '../../ressources/language/type';
import {clearHeader, setHeader}						from '../../redux/settings/settings';
import {DevicesState}								from '../../redux/devices/interface';
import {MdmDeviceGroupJamf, MdmDevice}				from '../../redux/devices/interfaceMdm';
import {assignDevicesApi, getDevicesApi,
	getMdmDevicesApi}								from '../../redux/devices/devices';
import {UserNotNull}								from '../../redux/user/interface';
import {InputValues}								from '../../ressources/components/Input/interface';

import {ft_genNotification, ft_pushNotification} 	from '../../ressources/functions/notification';
import {ft_formatUserName}							from '../../ressources/functions/format';
import {ft_selectDataUser}							from '../../ressources/functions/selectData';
import {ft_checkMdmDeviceFilters}					from '../../ressources/functions/filters';
import {ft_getDeviceName, ft_getDeviceType}			from '../../ressources/functions/deviceFunction';
import ft_cssVar									from '../../ressources/functions/getCssVar';
import {ft_search}									from '../../ressources/functions/search';

import img_computer									from '../../ressources/images/icon/devices/computer.svg';
import img_deviceIcon								from '../../ressources/images/icon/devices/computer.svg';
import img_usersPlus								from '../../ressources/images/icon/users-plus.svg';
import img_plus										from '../../ressources/images/icon/plus.svg';
import img_send										from '../../ressources/images/icon/send.svg';
import img_check									from '../../ressources/images/icon/check.svg';
import img_eye										from '../../ressources/images/icon/eye-open.svg';
import img_filter									from '../../ressources/images/icon/filter.svg';
import img_refresh									from '../../ressources/images/icon/refresh.svg';

import LANGUAGE										from '../../ressources/language';
import * as API										from '../../ressources/API';

import './Mdm.css';

interface History {
	command: string,
	date: Date,
	device: {
		_id: string,
		serial: string,
		name: string,
	}
	success: boolean,
	user: {
		_id: string,
		firstname: string,
		lastname: string
	},
	data?: {
		account?: string
	}
	jamf?: {
		status: 'PENDING' | 'ERROR' | 'ACKNOWLEDGED' | string,
		response: string
	}
}

interface Props {
	mdmConnected: (keyof DevicesState['mdm'])[]
}


function DevicesMdm(props: Props) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const devices = useAppSelector(state => state.devices.data);
	const mdmDevices = useAppSelector(state => state.devices.mdm);
	const lang = useAppSelector(state => state.settings.lang);
	const userReload = useAppSelector(state => state.user.reload);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [deviceView, set_deviceView] = useState('');
	const [modal, set_modal] = useState<string | null>(null);

	// --- Home
	const [selectedList, set_selectedList] = useState<MdmDevice[]>([]);
	const [homeView, set_homeView] = useState<TabsValues>('devices');
	const [filters, set_filters] = useState<FilterChecked[]>([]);
	const [modalCommand, set_modalCommand] = useState<keyof LanguageType['devices']['mdm']['actions'] | null>(null);
	const [jamfGroups, set_jamfGroups] = useState<MdmDeviceGroupJamf[]>([]);
	const [invitationList, set_invitationList] = useState<string[]>([]);
	const [invitationSend, set_invitationSend] = useState<{[i: string]: string}>({});
	const [modalAssign, set_modalAssign] = useState<boolean | string>(false);
	const [search, set_search] = useState<InputValues>('');

	// --- History
	const [history, set_history] = useState<History[]>([]);

	const [load, set_load] = useState(false);

	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const TEXTE = LANGUAGE(lang);

	const enrollCount = useMemo(() => {
		let count = 0;

		Object.values(mdmDevices).forEach((mdmData) => {
			count += mdmData.filter(mdm => devices.some(device => device.serial === mdm.serial)).length;
		});

		return count;
	}, [devices, mdmDevices]);

	useEffect(() => {
		dispatch(getDevicesApi(user));
		props.mdmConnected.forEach(actualMdm =>	(
			dispatch(getMdmDevicesApi({name: actualMdm, user}))
		));
	}, [userReload]);

	useEffect(() => set_homeView(searchParams.get('view') || 'devices'), [searchParams]);

	useEffect(() => {
		if (!deviceView)
			return;
		dispatch(setHeader({
			function: () => set_deviceView(''),
			render:   TEXTE.devices.mdm.backToMdm
		}));

		return () => {
			dispatch(clearHeader());
		};
	}, [deviceView]);

	useEffect(() => {
		set_invitationSend({});

		if (homeView === 'devices' || homeView === 'configuration') {
			set_load(true);

			API.getMdmDeviceGroupsJamf(false, user)
			.then((responseComputer) => {
				API.getMdmDeviceGroupsJamf(true, user)
				.then((responseMobile) => {
					set_jamfGroups([...responseComputer?.data || [], ...responseMobile?.data || []]);
					set_load(false);
				});
			});
		}

		if (homeView === 'history') {
			set_load(true);

			props.mdmConnected.forEach((actualMdm) => {
				API.getMdmHistory(actualMdm, user)
				.then((response) => {
					set_history(response.data || []);
					set_load(false);
				});
			});
		}
	}, [homeView]);

	function assignDevice(assignUser: UserNotNull) {
		if (typeof modalAssign !== 'string')
			return;

		set_load(true);

		dispatch(assignDevicesApi({
			user,
			assignUser,
			devicesId:  [modalAssign]
		})).then(() => {
			const notificationData = ft_genNotification(TEXTE, 'assignDeviceSuccess', img_deviceIcon, ft_formatUserName(assignUser));
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_load(false);
			set_modalAssign(false);
		});
	}

	async function sendInvitations(actualMdm: keyof DevicesState['mdm'], list: string[], indexList?: number) {
		set_load(true);

		if (indexList !== undefined)
			set_invitationSend({...invitationSend, [`${indexList}-${actualMdm}`]: 'load'});

		API.postMdmInvitations(actualMdm, list, user)
		.then((response) => {
			set_load(false);

			if (indexList !== undefined)
				set_invitationSend({...invitationSend, [`${indexList}-${actualMdm}`]: 'end'});

			if (!response.status) {
				const notificationData = ft_genNotification(TEXTE, 'error', img_computer, response.error, 'error');
				return ft_pushNotification(dispatch, notificationId, notificationData);
			}

			const notificationData = ft_genNotification(TEXTE, response.data.success === 1 ? 'mdmInvitationSendSingle' : 'mdmInvitationSend', img_computer, response.data.success);
			ft_pushNotification(dispatch, notificationId, notificationData);
		});
	}

	function renderHomeEmpty() {
		return (
			<>
				<div className={'flex-center'} style={{gap: 8}}>
					{props.mdmConnected.map((name, i) => (
						<Button
							key={i}
							size={'sm'}
							type={'secondary-gray'}
							iconBefore={img_plus}
							onClick={() => navigate(`${name}/import`)}
						>
							{TEXTE.devices.mdm.importDevices}
							{props.mdmConnected.length > 1 &&
								` ${TEXTE.component.externalApi[name]}`
							}
						</Button>
					))}
					<div className={'flex'} />
				</div>
				<div className={'globalAddContainer flex'} style={{border: 'unset'}}>
					<div className={'flex flex-center'}>
						<Icon
							iconBorder
							size={36}
							iconSize={24}
							borderSize={8}
							icon={img_computer}
						/>
						<span className={'text-md weight-600 gray-900'}>{TEXTE.devices.mdm.noSyncDevices}</span>
						<span className={'gray-600'}>{TEXTE.devices.mdm.importForManage}</span>
					</div>
				</div>
			</>
		);
	}

	function renderHomeDevices() {
		if (enrollCount === 0)
			return renderHomeEmpty();

		const renderActionButton = (name: keyof LanguageType['devices']['mdm']['actions']) => {
			let disabled = selectedList.length === 0;

			if (!disabled && name === 'setConfiguration')
				disabled = !selectedList.every(e => e.type === selectedList[0].type);

			if (selectedList.some(find => find.mdm === 'vmWare')) {
				if (name === 'setConfiguration')
					return;
				if (name !== 'shutDown_short')
					disabled = true;
			}

			return (
				<Button
					size={'sm'}
					disabled={disabled}
					type={'secondary-gray'}
					onClick={() => set_modalCommand(name)}
				>
					{TEXTE.devices.mdm.actions[name]}
					{(name === 'erase' && selectedList.some(find => find.mdm === 'jamf')) &&
						<Badge
							text={TEXTE.global.soon}
							size={'sm'}
							color={'gray'}
							style={{opacity: 0.6}}
						/>
					}
				</Button>
			);
		};
		const renderTable: React.ReactElement[] = [];
		let filterCount = 0;

		filters.forEach(filter => filterCount += filter.values.length);

		[...devices].filter((device) => {
			const deviceUser = users.find(find => find && find._id === device?.user);
			const type = ft_getDeviceType(device);

			if (search && !ft_search([device.name, device.serial, ft_formatUserName(deviceUser)], search, true, true))
				return false;

			return type === 'computer' || type === 'phone' || type === 'tablet';
		}).sort((a, b) => {
			let dA = false;
			let dB = false;

			Object.values(mdmDevices).forEach((mdmData) => {
				dA = dA || mdmData.some(find => find.serial === a.serial);
				dB = dB || mdmData.some(find => find.serial === b.serial);
			});

			if (dA === dB)
				return 0;
			return dA ? -1 : 1;
		}).forEach((deviceData, i) => {
			const renderInvitation = () => {
				if (mdmName.length)
					return mdmName;

				const type = ft_getDeviceType(deviceData);
				const brand = deviceData.notValalaData?.brand || deviceData.shopData?.info?.brand;
				let mdm = '';

				if (brand?.toLowerCase() === 'apple' && props.mdmConnected.includes('jamf'))
					mdm = 'jamf';
				else if (props.mdmConnected.includes('vmWare')) {
					if (type === 'computer' || brand?.toLowerCase() === 'apple')
						mdm = 'vmWare';
				}

				if (!mdm && brand && type !== 'computer' && brand.toLowerCase() !== 'apple')
					return <Badge color={'gray'} text={TEXTE.devices.mdm.unavailable} />;

				if (!assign)
					return <Badge color={'warning'} text={TEXTE.devices.mdm.assign} />;

				if (mdm) {
					return (
						<Badge
							color={'gray'}
							key={`invit-${index}`}
							text={TEXTE.devices.mdm.sendAInvitation}
							onClick={() => {
								if (!invitationSend[`${i}-${mdm}`])
									sendInvitations(mdm as keyof DevicesState['mdm'], [assign], i);
							}}
						>
							{invitationSend[`${i}-${mdm}`] === 'load' ?
								<Load size={14} />
								:
								<Icon
									iconSize={14}
									icon={!invitationSend[`${i}-${mdm}`] ? img_send : img_check}
									iconColor={!invitationSend[`${i}-${mdm}`] ? ft_cssVar('gray-700') : ft_cssVar('success-400')}
								/>
							}
						</Badge>
					);
				}

				if (brand && !props.mdmConnected.includes('vmWare'))
					return <Badge color={'gray'} text={TEXTE.devices.mdm.vmWareOnly} />;

				return (
					<Badge
						color={'gray'}
						text={TEXTE.devices.mdm.invitationPage}
						onClick={() => navigate('?view=invitation')}
					>
						<Icon
							iconSize={14}
							icon={img_plus}
							iconColor={ft_cssVar('gray-700')}
						/>
					</Badge>
				);
			};

			const mdmName: React.ReactElement[] = [];
			let mdmDevice: MdmDevice | undefined;
			let assign = '';

			props.mdmConnected.forEach((name) => {
				const mdmFind = mdmDevices[name]?.find(find => find.serial === deviceData.serial);

				if (!mdmFind)
					return;

				mdmDevice = mdmFind;
				mdmName.push(<Badge key={`${i}-${name}`} color={'success'} text={TEXTE.component.externalApi[name]} />);
			});

			if (deviceData.user)
				assign = typeof(deviceData.user) === 'string' ? deviceData.user : deviceData.user._id;

			const onClick = () => {
				if (!mdmDevice)
					return;

				const copy = [...selectedList];

				if (index === -1)
					copy.push(mdmDevice);
				else
					copy.splice(index, 1);

				set_selectedList(copy);
			};

			if (filters.length && (!mdmDevice || !ft_checkMdmDeviceFilters(filters, mdmDevice)))
				return;

			const index = selectedList.findIndex(find => find.serial === deviceData.serial);

			renderTable.push(
				<tr
					onClick={onClick}
					key={`mdmDevice-${i}`}
					className={index !== -1 ? 'tableRow selected' : ''}
				>
					<td>
						{mdmDevice?.mdm === 'Jamf' &&
							<div className={'flex-center'}>
								<Checkbox active={index !== -1} />
							</div>
						}
					</td>
					<td>{ft_getDeviceName(deviceData)}</td>
					<td>{deviceData.serial}</td>
					<td>
						<div>
							{assign ?
								<Select
									value={assign}
									data={ft_selectDataUser(users)}
									onClick={() => set_modalAssign(deviceData._id)}
								/>
								:
								<Badge
									color={'gray'}
									img={img_usersPlus}
									text={TEXTE.global.affect}
									onClick={() => set_modalAssign(deviceData._id)}
								/>
							}
						</div>
					</td>
					<td>
						{renderInvitation()}
					</td>
					{props.mdmConnected.includes('jamf') &&
						<td>
							<div>
								{
									jamfGroups.filter(find => find.computers?.some(e => e.id === mdmDevice?.id) || find.mobile_devices?.some(e => e.id === mdmDevice?.id))
									.map((e, i2) => <Badge key={i2} size={'sm'} text={e.name} />)
								}
							</div>
						</td>
					}
					<td>
						<div onClick={e => e.stopPropagation()}>
							<Icon icon={img_eye} onClick={() => set_deviceView(deviceData._id)} />
						</div>
					</td>
				</tr>
			);
		});

		return (
			<>
				<div className={'flex-center'} style={{gap: 8}}>
					{props.mdmConnected.map((name, i) => (
						<Button
							key={i}
							size={'sm'}
							type={'secondary-gray'}
							iconBefore={img_plus}
							onClick={() => navigate(`${name}/import`)}
						>
							{TEXTE.devices.mdm.importDevices}
							{props.mdmConnected.length > 1 &&
								` ${TEXTE.component.externalApi[name]}`
							}
						</Button>
					))}
					<div className={'flex'} />
					<Button
						size={'sm'}
						type={'tertiary-gray'}
						iconBefore={img_filter}
						onClick={() => set_modal('filter')}
					>
						{TEXTE.global.filter}
						{filterCount > 0 && <Badge size={'sm'} color={'gray'} text={filterCount} />}
					</Button>
					{filters.length > 0 &&
						<Icon
							icon={img_refresh}
							popup={TEXTE.global.reset}
							onClick={() => set_filters([])}
						/>
					}
				</div>
				{props.mdmConnected.includes('jamf') &&
					<div className={'flex-row'} style={{gap: 8}}>
						{renderActionButton('setConfiguration')}
						{renderActionButton('reset')}
						{renderActionButton('restart_short')}
						{renderActionButton('shutDown_short')}
						{renderActionButton('addAccount')}
					</div>
				}
				<Input
					type={'search'}
					value={search}
					onChange={set_search}
					placeholder={TEXTE.global.search}
				/>
				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th style={{width: 50}} />
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.global.serial}</th>
							<th>{TEXTE.global.owner}</th>
							<th>{TEXTE.devices.mdm.enroll}</th>
							{props.mdmConnected.includes('jamf') && <th>{TEXTE.devices.mdm.configuration}</th>}
							<th style={{width: 50}}>{TEXTE.global.see}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>

				{modalAssign &&
					<ModalAssign
						modalRight
						load={load}
						onClose={() => set_modalAssign(false)}
						onConfirm={(newAssign) => {
							const newUser = users.find(find => find?._id === newAssign);

							if (newUser)
								assignDevice(newUser);
							set_modalAssign(false);
						}}
					/>
				}
			</>
		);
	}

	function renderHomeConfiguration() {
		const render: React.ReactElement[] = [];

		jamfGroups.forEach((group, i) => {
			render.push(
				<Section
					key={`group-${i}`}
					title={`${TEXTE.devices.mdm.configuration} ${group.name}`}
					afterTitle={
						<Badge
							size={'sm'}
							color={'gray'}
							text={group.computers?.length || group.mobile_devices?.length || 0}
						/>
					}
				/>
			);
		});

		return (
			<>
				{load ? <Load center /> : render}
			</>
		);
	}

	function renderHomeInvitation() {
		return (
			<>
				<ModalAssign
					multiple
					notModal
					onChange={(_, list) => set_invitationList(list || [])}
				/>
			</>
		);
	}

	function renderHomeHistory() {
		const renderTable: React.ReactElement[] = [];
		let filterCount = 0;

		filters.forEach(filter => filterCount += filter.values.length);

		history.forEach((historyData, i) => {
			const commandOver = historyData.jamf?.status?.toUpperCase() !== 'PENDING';
			let command: (keyof LanguageType['devices']['mdm']['actions'] | null) = null;
			let success = false;

			if (historyData.command === 'RESTART_DEVICE' || historyData.command === 'SoftReset')
				command = 'restart_short';
			else if (historyData.command === 'SHUT_DOWN_DEVICE' || historyData.command === 'Shutdown')
				command = 'shutDown_short';
			else if (historyData.command === 'ERASE_DEVICE' || historyData.command === 'DeviceWipe')
				command = 'reset';
			else if (historyData.command === 'LOCK_DEVICE' || historyData.command === 'Lock')
				command = 'lock';
			else if (historyData.command === 'DELETE_USER')
				command = 'deleteAccount';
			else if (historyData.command === 'ADD_USER')
				command = 'addAccount';

			if (!historyData.jamf && historyData.success)
				success = true;
			else if (historyData.jamf && historyData.jamf.status !== 'ERROR')
				success = true;

			renderTable.push(
				<tr key={`mdmHistory-${i}`}>
					<td>
						{commandOver ?
							<Badge
								size={'sm'}
								color={success ? 'success' : 'error'}
								text={TEXTE.devices.mdm[success ? 'historySuccess' : 'historyError']}
							/>
							:
							<Badge
								size={'sm'}
								color={'gray'}
								text={TEXTE.devices.mdm.historyPending}
							/>
						}
					</td>
					<td>{moment(historyData.date).format('DD/MM/YY HH:mm:ss')}</td>
					<td>
						{command ? TEXTE.devices.mdm.actions[command] : historyData.command}
						{(historyData.data?.account) && ` (${historyData.data?.account})`}
					</td>
					<td>
						{(commandOver && !success) && historyData.jamf?.response}
						{!commandOver && TEXTE.devices.mdm.historyMessage.pending}
					</td>
					<td>
						{`${historyData.device.name} - ${historyData.device.serial}`}
					</td>
				</tr>
			);
		});

		return (
			<table className={'importTable'}>
				<thead>
					<tr style={{textAlign: 'left'}}>
						<th style={{width: 100}}>{TEXTE.devices.mdm.historyStatus}</th>
						<th>{TEXTE.devices.mdm.historyDate}</th>
						<th>{TEXTE.devices.mdm.historyCommand}</th>
						<th>{TEXTE.devices.mdm.historyMessage.name}</th>
						<th>{TEXTE.global.device}</th>
					</tr>
				</thead>
				<tbody>
					{renderTable}
				</tbody>
			</table>
		);
	}

	function renderHome() {
		return (
			<div className={'globalDataContainerItem column flex'} style={{overflow: 'auto'}}>
				<div>
					<Tabs
						button
						alignLeft
						actual={homeView}
						onChange={set_homeView}
						data={[
							{value: 'devices', render: TEXTE.global.devices},
							// ...(props.mdmConnected.includes('jamf') ? [{value: 'configuration', render: TEXTE.devices.mdm.configuration}] : []),
							{value: 'invitation', render: TEXTE.devices.mdm.invitation},
							{value: 'history', render: TEXTE.devices.historical}
						]}
					/>
				</div>
				{homeView === 'devices' && renderHomeDevices()}
				{homeView === 'configuration' && renderHomeConfiguration()}
				{homeView === 'invitation' && renderHomeInvitation()}
				{homeView === 'history' && renderHomeHistory()}
			</div>
		);
	}

	function renderButtonContainer() {
		const render: React.ReactElement[] = [];

		props.mdmConnected.forEach((name) => {
			render.push(
				<Button
					fullWidth
					isLoad={load}
					disabled={invitationList.length === 0}
					onClick={() => sendInvitations(name, invitationList)}
				>
					{TEXTE.devices.mdm.sendInvitations}
					{props.mdmConnected.length > 1 && ` - ${TEXTE.component.externalApi[name]}`}
				</Button>
			);
		});

		return (
			<ButtonStickyContainer noFlex>
				{render}
			</ButtonStickyContainer>
		);
	}

	if (deviceView)
		return <><br /><Devices forceId={deviceView} /></>;

	return (
		<>
			<br />
			{renderHome()}
			{homeView === 'invitation' && renderButtonContainer()}

			{modal === 'filter' &&
				<ModalFilter
					isMdm
					filters={filters}
					setFilters={set_filters}
					onClose={() => set_modal(null)}
				/>
			}
			{modalCommand &&
				<ModalMdmCommand
					mdmName={'jamf'}
					modalCommand={modalCommand}
					mdmDeviceList={selectedList}
					onClose={() => set_modalCommand(null)}
				/>
			}
			<br />
		</>
	);
}

export default DevicesMdm;
